import { FilterIcon } from 'foundations-assets/icons/components/FilterIcon';
import MobileTopFilterPanel from '../../../containers/TracksPage/MobileTopFilterPanel';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const MobileFilterButton = ({
  totalCount,
  mobileFilterTypes
}) => {
  const [filterPanelOpen, setFilterPanelOpen] = useState(false);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(IconButton, {
      "data-test-id": "mobile-filter-panel-button",
      onClick: () => setFilterPanelOpen(true),
      size: "medium",
      use: "transparent",
      children: /*#__PURE__*/_jsx(FilterIcon, {
        color: "icon-core-subtle",
        size: "600"
      })
    }), /*#__PURE__*/_jsx(MobileTopFilterPanel, {
      "data-test-id": "mobile-secondary-filter-panel",
      itemsCount: totalCount,
      mobileFilterTypes: mobileFilterTypes,
      onCloseClick: () => setFilterPanelOpen(false),
      open: filterPanelOpen
    })]
  });
};